module.exports = __webpack_public_path__ + "img/clipboard_without_events.6e193e78.svg";